import {
  Container,
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Navbar from '../components/Navbar';

const FAQ = () => {
  const faqData = [
    {
      question: "Which AMIs are included in database?",
      answer: "Currently only AMIs from non-Amazon-verified accounts are included, however there is an exception to that rule. For any AMI that meets the scanning criteria below, if that AMI has a parent AMI, that AMI is scanned, included in the database, even if it is served from a verified account."
    },
    {
      question: "Which AMIs are not included?",
      answer: "AMIs served from AWS accounts that AWS considers \"verified\" (the ones that have an OwnerAlias of amazon or aws-marketplace).  If an AMI meets the scanning criteria below, the any AMIs that were used as source AMIs for the scanned AMI are also scanned and included."
    },    
    {
      question: "Which AMIs have their filesystems scanned for file hashes?",
      answer: "If the account serving the newly observed AMI has fewer than 25 AMIs in our database, the AMI is scanned. Also, AMIs that are parents of AMIs that meet the this criteria are also scanned."
    },
    {
      question: "What regions are currently supported?",
      answer: "Cloud Image Investigator currently supports the following AWS regions: ap-south-1, eu-north-1, eu-west-3, eu-west-2, eu-west-1, ap-northeast-3, ap-northeast-2, ap-northeast-1, ca-central-1, sa-east-1, ap-southeast-1, ap-southeast-2, eu-central-1, us-east-1, us-east-2, us-west-1, us-west-2, and mx-central-1.  Support for the remaining regions is coming soon (with the exception of Mainland China and GovCloud regions)"
    },
    {
      question: "Do you plan to support more regions?",
      answer: "Yes! Support for the remaining regions is coming soon (with the exception of Mainland China and GovCloud regions)"
    },
    {
      question: "Are there any known issues?",
      answer: "Yes! Currently NTFS filesystems are not being scanned. That will be fixed shortly."
    },
    {
      question: "How can I submit feedback, bugs, issues, or suggestions?",
      answer: "Great question. We're working on that."
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, pb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', mb: 2 }}>
        <Navbar />
      </Box>
      
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600, color: 'primary.main' }}>
          Frequently Asked Questions
        </Typography>
        <Typography variant="h6" color="text.secondary" paragraph>
          Find answers to common questions about Cloud Image Investigator
        </Typography>
      </Box>

      <Paper 
        elevation={2} 
        sx={{ 
          p: 3, 
          borderRadius: 3,
          background: 'rgba(255,255,255,0.95)',
          backdropFilter: 'blur(10px)'
        }}
      >
        {faqData.map((faq, index) => (
          <Accordion 
            key={index}
            sx={{ 
              mb: 2,
              '&:before': { display: 'none' },
              borderRadius: 2,
              '&:last-child': { mb: 0 }
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(25, 118, 210, 0.04)',
                },
                borderRadius: 2,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 500, color: 'text.primary' }}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0 }}>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Paper>
    </Container>
  );
};

export default FAQ; 